const { createAction } = require('../helpers')
const {
  // for admin panel
  GET_PARTNER_LIST,
  GET_PARTNER_LIST_SUCCESS,
  GET_PARTNER_LIST_ERROR,
  GET_PARTNER_LIST_RESET,

  // for admin panel
  GET_PARTNER,
  GET_PARTNER_SUCCESS,
  GET_PARTNER_ERROR,
  GET_PARTNER_RESET,

  // for admin panel
  CREATE_PARTNER,
  CREATE_PARTNER_SUCCESS,
  CREATE_PARTNER_ERROR,
  CREATE_PARTNER_RESET,

  // for admin panel
  UPDATE_PARTNER,
  UPDATE_PARTNER_SUCCESS,
  UPDATE_PARTNER_ERROR,
  UPDATE_PARTNER_RESET,

  // for admin panel
  DELETE_PARTNER,
  DELETE_PARTNER_SUCCESS,
  DELETE_PARTNER_ERROR,
  DELETE_PARTNER_RESET,

  // for doctor/patient app
  GET_PARTNER_DATA,
  GET_PARTNER_DATA_SUCCESS,
  GET_PARTNER_DATA_ERROR,
  GET_PARTNER_DATA_RESET,
} = require('./constants')

// for admin panel
const getPartnerList = ({ skip, take, name, search }) => createAction(GET_PARTNER_LIST, { skip, take, name, search })
const getPartnerListSuccess = data => createAction(GET_PARTNER_LIST_SUCCESS, { data })
const getPartnerListError = error => createAction(GET_PARTNER_LIST_ERROR, { error })
const getPartnerListReset = () => createAction(GET_PARTNER_LIST_RESET)

// for admin panel
const getPartner = id => createAction(GET_PARTNER, { id })
const getPartnerSuccess = data => createAction(GET_PARTNER_SUCCESS, { data })
const getPartnerError = error => createAction(GET_PARTNER_ERROR, { error })
const getPartnerReset = () => createAction(GET_PARTNER_RESET)

// for admin panel
const createPartner = partnerData => createAction(CREATE_PARTNER, { partnerData })
const createPartnerSuccess = data => createAction(CREATE_PARTNER_SUCCESS, { data })
const createPartnerError = error => createAction(CREATE_PARTNER_ERROR, { error })
const createPartnerReset = () => createAction(CREATE_PARTNER_RESET)

// for admin panel
const updatePartner = ({ id, partnerData }) => createAction(UPDATE_PARTNER, { id, partnerData })
const updatePartnerSuccess = data => createAction(UPDATE_PARTNER_SUCCESS, { data })
const updatePartnerError = error => createAction(UPDATE_PARTNER_ERROR, { error })
const updatePartnerReset = () => createAction(UPDATE_PARTNER_RESET)

// for admin panel
const deletePartner = ({ id }) => createAction(DELETE_PARTNER, { id })
const deletePartnerSuccess = data => createAction(DELETE_PARTNER_SUCCESS, { data })
const deletePartnerError = error => createAction(DELETE_PARTNER_ERROR, { error })
const deletePartnerReset = () => createAction(DELETE_PARTNER_RESET)

// for doctor/patient app
const getPartnerData = id => createAction(GET_PARTNER_DATA, { id })
const getPartnerDataSuccess = data => createAction(GET_PARTNER_DATA_SUCCESS, { data })
const getPartnerDataError = error => createAction(GET_PARTNER_DATA_ERROR, { error })
const getPartnerDataReset = () => createAction(GET_PARTNER_DATA_RESET)

module.exports = {
  // for admin panel
  getPartnerList,
  getPartnerListSuccess,
  getPartnerListError,
  getPartnerListReset,
  getPartner,
  getPartnerSuccess,
  getPartnerError,
  getPartnerReset,
  createPartner,
  createPartnerSuccess,
  createPartnerError,
  createPartnerReset,
  updatePartner,
  updatePartnerSuccess,
  updatePartnerError,
  updatePartnerReset,
  deletePartner,
  deletePartnerSuccess,
  deletePartnerError,
  deletePartnerReset,

  // for doctor/patient app
  getPartnerData,
  getPartnerDataSuccess,
  getPartnerDataError,
  getPartnerDataReset,
}
